<div [formGroup]="advertForm" class="form-check" *ngIf="'copyright_checkbox'+uuid as checkboxId">
  <input class="form-check-input" formControlName="copyrightStatus" type="checkbox" [id]="checkboxId" [ngClass]="{ 'is-invalid': isInvalid() }">
  <label class="form-check-label" [for]="checkboxId">
    {{ 'campaign.ad.copyrightMessage' | translate }}
  </label>
  <div [ngClass]="{ 'invalid-feedback': isInvalid()}" class="form-text">
    {{ 'validation.required' | translate }}
  </div>
</div>
